import React from 'react';

// Stroke icons used across Glacier. Stroke-based, currentColor, round caps.
// Ported from design/icons.jsx::Icon. Adding a new icon? Extend the switch and
// re-export `iconNames` so tests pick it up automatically.
export const iconNames = [
  'send',
  'party',
  'close',
  'share',
  'copy',
  'plus',
  'check',
  'sparkle',
  'flame',
  'link',
  'users',
  'globe',
  'lock',
  'logout',
  'refresh',
  'moon',
  'sun',
  'menu',
  'smile',
  'reply',
  'dot',
  'wifi',
  'cloud',
  'radar',
  'phone-device',
  'monitor',
  'zap',
  'lan',
  'upload',
  'image',
  'file',
  'folder',
  'code',
  'chevron-down',
  'pause',
  'download',
  'paperclip',
  'alert',
];

const Icon = ({
  name,
  size = 24,
  strokeWidth = 1.75,
  className,
  style,
  'aria-label': ariaLabel,
  ...rest
}) => {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    className,
    style,
    'aria-hidden': ariaLabel ? undefined : true,
    'aria-label': ariaLabel,
    role: ariaLabel ? 'img' : undefined,
    focusable: 'false',
    ...rest,
  };

  switch (name) {
    case 'send':
      return (
        <svg {...common}>
          <path d="M3.5 12 21 4l-7 17-3.2-7.2L3.5 12Z" />
          <path d="m10.8 13.2 5.7-5.7" />
        </svg>
      );
    case 'party':
      return (
        <svg {...common}>
          <path d="M4 20 14 6l4 4L4 20Z" />
          <path d="m14 6 4 4" />
          <path d="M17 3v2M20 6h2M19.5 9.5l1.5-1.5" />
          <circle cx="9" cy="14" r="0.7" fill="currentColor" stroke="none" />
          <circle cx="6.5" cy="17" r="0.5" fill="currentColor" stroke="none" />
        </svg>
      );
    case 'close':
      return (
        <svg {...common}>
          <path d="M6 6l12 12M18 6 6 18" />
        </svg>
      );
    case 'share':
      return (
        <svg {...common}>
          <circle cx="18" cy="5" r="2.5" />
          <circle cx="6" cy="12" r="2.5" />
          <circle cx="18" cy="19" r="2.5" />
          <path d="m8.2 10.8 7.6-4.6M8.2 13.2l7.6 4.6" />
        </svg>
      );
    case 'copy':
      return (
        <svg {...common}>
          <rect x="8" y="8" width="12" height="12" rx="2.5" />
          <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" />
        </svg>
      );
    case 'plus':
      return (
        <svg {...common}>
          <path d="M12 5v14M5 12h14" />
        </svg>
      );
    case 'check':
      return (
        <svg {...common}>
          <path d="M4 12.5 9 17.5 20 6.5" />
        </svg>
      );
    case 'sparkle':
      return (
        <svg {...common}>
          <path d="M12 3v4M12 17v4M3 12h4M17 12h4" />
          <path d="m6.3 6.3 2.4 2.4M15.3 15.3l2.4 2.4M17.7 6.3l-2.4 2.4M8.7 15.3l-2.4 2.4" />
        </svg>
      );
    case 'flame':
      return (
        <svg {...common}>
          <path d="M12 3c1 3 4 4.5 4 8a4 4 0 0 1-8 0c0-1.5.5-2.5 1.5-3.5C10.5 6 11 4.5 12 3Z" />
          <path d="M12 14c.5 1.2 1.5 1.8 1.5 2.8a1.5 1.5 0 0 1-3 0c0-.6.3-1 .7-1.4" />
        </svg>
      );
    case 'link':
      return (
        <svg {...common}>
          <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 1 0-5.7-5.7l-1.2 1.2" />
          <path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 1 0 5.7 5.7l1.2-1.2" />
        </svg>
      );
    case 'users':
      return (
        <svg {...common}>
          <circle cx="9" cy="9" r="3.2" />
          <path d="M3 19c.6-3 3-4.5 6-4.5s5.4 1.5 6 4.5" />
          <path d="M15 5.2a3.2 3.2 0 0 1 0 6.2" />
          <path d="M16.5 14.6c2.4.4 4 1.8 4.5 4.4" />
        </svg>
      );
    case 'globe':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M3 12h18M12 3c2.5 2.7 3.8 5.7 3.8 9s-1.3 6.3-3.8 9c-2.5-2.7-3.8-5.7-3.8-9S9.5 5.7 12 3Z" />
        </svg>
      );
    case 'lock':
      return (
        <svg {...common}>
          <rect x="4.5" y="10.5" width="15" height="10" rx="2" />
          <path d="M8 10.5V7a4 4 0 0 1 8 0v3.5" />
        </svg>
      );
    case 'logout':
      return (
        <svg {...common}>
          <path d="M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4" />
          <path d="M10 8 6 12l4 4M6 12h10" />
        </svg>
      );
    case 'refresh':
      return (
        <svg {...common}>
          <path d="M4 12a8 8 0 0 1 14-5.3L20 9" />
          <path d="M20 4v5h-5" />
          <path d="M20 12a8 8 0 0 1-14 5.3L4 15" />
          <path d="M4 20v-5h5" />
        </svg>
      );
    case 'moon':
      return (
        <svg {...common}>
          <path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5Z" />
        </svg>
      );
    case 'sun':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="3.5" />
          <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4 7 17M17 7l1.4-1.4" />
        </svg>
      );
    case 'menu':
      return (
        <svg {...common}>
          <path d="M5 7h14M5 12h14M5 17h14" />
        </svg>
      );
    case 'smile':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M8.5 14.5c1 1.3 2.2 2 3.5 2s2.5-.7 3.5-2" />
          <circle cx="9" cy="10" r="0.7" fill="currentColor" stroke="none" />
          <circle cx="15" cy="10" r="0.7" fill="currentColor" stroke="none" />
        </svg>
      );
    case 'reply':
      return (
        <svg {...common}>
          <path d="M10 5 4 11l6 6" />
          <path d="M4 11h9a6 6 0 0 1 6 6v2" />
        </svg>
      );
    case 'dot':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="4" fill="currentColor" stroke="none" />
        </svg>
      );
    case 'wifi':
      return (
        <svg {...common}>
          <path d="M3 8.5C6 6 9 4.8 12 4.8S18 6 21 8.5" />
          <path d="M6 12C7.8 10.5 9.8 9.7 12 9.7s4.2.8 6 2.3" />
          <path d="M9 15.5c.9-.8 1.9-1.2 3-1.2s2.1.4 3 1.2" />
          <circle cx="12" cy="19" r="1" fill="currentColor" stroke="none" />
        </svg>
      );
    case 'cloud':
      return (
        <svg {...common}>
          <path d="M7 18a4 4 0 0 1-.5-7.97 5 5 0 0 1 9.6-1.2A3.5 3.5 0 0 1 17.5 18H7Z" />
        </svg>
      );
    case 'radar':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <circle cx="12" cy="12" r="5" />
          <circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none" />
          <path d="M12 12 19 7" />
        </svg>
      );
    case 'phone-device':
      return (
        <svg {...common}>
          <rect x="7" y="3" width="10" height="18" rx="2.5" />
          <path d="M11 18h2" />
        </svg>
      );
    case 'monitor':
      return (
        <svg {...common}>
          <rect x="3" y="4.5" width="18" height="12" rx="2" />
          <path d="M9 20.5h6M12 16.5v4" />
        </svg>
      );
    case 'zap':
      return (
        <svg {...common}>
          <path d="M13 3 4.5 13.5H11l-1 7.5 8.5-10.5H12l1-7.5Z" />
        </svg>
      );
    case 'lan':
      return (
        <svg {...common}>
          <rect x="9.5" y="3.5" width="5" height="4" rx="1" />
          <rect x="3" y="16.5" width="5" height="4" rx="1" />
          <rect x="9.5" y="16.5" width="5" height="4" rx="1" />
          <rect x="16" y="16.5" width="5" height="4" rx="1" />
          <path d="M12 7.5v4M5.5 16.5v-2.5h13v2.5M12 14v2.5" />
        </svg>
      );
    case 'upload':
      return (
        <svg {...common}>
          <path d="M12 20V9M7.5 13.5 12 9l4.5 4.5" />
          <path d="M5 5h14" />
        </svg>
      );
    case 'image':
      return (
        <svg {...common}>
          <rect x="4" y="5" width="16" height="14" rx="2.5" />
          <circle cx="9" cy="10" r="1.6" />
          <path d="m5 17 4.5-4.5a1.5 1.5 0 0 1 2 0L18 18" />
        </svg>
      );
    case 'file':
      return (
        <svg {...common}>
          <path d="M13 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9l-6-6Z" />
          <path d="M13 3v6h6" />
        </svg>
      );
    case 'folder':
      return (
        <svg {...common}>
          <path d="M4 7a2 2 0 0 1 2-2h3l2 2.5h7a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7Z" />
        </svg>
      );
    case 'code':
      return (
        <svg {...common}>
          <path d="m8 7-5 5 5 5M16 7l5 5-5 5" />
          <path d="m13.5 4-3 16" />
        </svg>
      );
    case 'chevron-down':
      return (
        <svg {...common}>
          <path d="m6 9 6 6 6-6" />
        </svg>
      );
    case 'pause':
      return (
        <svg {...common}>
          <path d="M8 5v14M16 5v14" />
        </svg>
      );
    case 'download':
      return (
        <svg {...common}>
          <path d="M12 4v11M7.5 10.5 12 15l4.5-4.5" />
          <path d="M5 19h14" />
        </svg>
      );
    case 'paperclip':
      return (
        <svg {...common}>
          <path d="M20 11.5 12 19.5a5 5 0 0 1-7-7l8-8a3.3 3.3 0 0 1 4.7 4.7l-8 8a1.7 1.7 0 0 1-2.4-2.4l7.3-7.3" />
        </svg>
      );
    case 'alert':
      return (
        <svg {...common}>
          <path d="M12 3 2.5 20h19L12 3Z" />
          <path d="M12 10v5M12 17.5v.5" />
        </svg>
      );
    default:
      return null;
  }
};

export default Icon;
